import React, {useEffect} from "react"
import Layout from "../components/layout"
// markup
const IndexPage = ({children,location}) => {
  useEffect(()=> {
  },[])
  return (
    <Layout location={location}>
      <h1>Welcome to my Creative Coding Course!!</h1>
      <h2>What even is creative coding?</h2>
      <p> I will define it three ways.</p>
      <ul className="definitions">
        <li><span className="highlight"> Understanding how code can help communicate our ideas and extend the possibilities of our creative production,</span> whether we write the code or not, and whether the code is directly involved in producing a final product or not.</li>
        <li>Less broadly, <span className="highlight">the practice of writing programs in service of a creative endeavor.</span> </li>
        <li>Most specifically, <span className="highlight">to write programs that directly produce a creative output.</span> </li>
      </ul>
      <h2>Course Sequence</h2>
      <p>This course will begin focusing on #1 above, the broadest definition, and work its way towards #3. </p>
      <ul>
        <li>I will introduce you to the essential tools and concepts needed to create websites. </li>
        <li>We will do a deep dive into <a href="https://developer.mozilla.org/en-US/docs/Learn/Getting_started_with_the_web/JavaScript_basics">Javascript,</a> the programming language of the web.</li>
        <li>We will write plain Javascript to make creative programs on web pages.</li>
        <li>We will use <i>javascript libraries</i> such as <a href="https://paperjs.org">paper.js</a> to create more advanced visual output.</li>
        <li>We will determine further uses of programming and the web to develop more projects based on the interests of students.</li>
      </ul>
      <p>By the end of this course, students will feel comfortable building websites from scratch, and conceptualize+execute creative programming projects.</p>
      <h2>Class structure</h2>
      <p> Classes will be held at <a rel="noreferrer" target="_blank" href="https://whereby.com/hvd">https://whereby.com/hvd</a>. They will roughly follow this format:</p>
      <ul>
        <li><b>Q&A: </b>I will answer any and all questions about the recent assignment due. PLEASE DON'T BE SHY!</li>
        <li><b>Lecture:</b> A short lecture about a new topic.</li>
        <li><b>Tutorial: </b>I will give a guided walkthrough on a new subject for students to follow along and ask questions if they get stuck.</li>
        <li><b>Assignment: </b>For the rest of class, students will begin work on a new assignment that will be due before the following class starts. Assignment submission process TBD.</li>
      </ul>
      <h2>Class Dates</h2>
      <div>
      <div>1)	Mon, 4. Apr. 2022	13:30</div>
      <div>2)	Mon, 11. Apr. 2022	13:30</div>
      <div>3)	Mon, 2. May 2022	13:30</div>
      <div>4)	Mon, 9. May 2022	13:30</div>
      <div>5)	Mon, 16. May 2022	13:30</div>
      <div>6)	Mon, 23. May 2022	13:30</div>
      <div>7)	Mon, 13. Jun. 2022	13:30</div>
      <div>8)	Mon, 20. Jun. 2022	13:30</div>
      <div>9)	Mon, 27. Jun. 2022	13:30</div>
      <div>10)	Mon, 4. Jul. 2022	13:30</div>
      </div>
      <p>:)<br></br>Henry</p>
      <p>PS if you ever have questions, do not hesitate to email me at <a href="mailto:henry@candusen.net">henry@candusen.net</a>!!!</p>
    </Layout>
  )
}

export default IndexPage
